import dayjs from "dayjs";

export default function dateToInputValue(value: Date): string {
  return dayjs(value).format("YYYY-MM-DD");
}
